<div class="headerdiv">
    <div >
      <h3 class="pagetitle">Partners Categories</h3>
      <label class="settings"><a>Settings</a> | <a>Analytics</a> </label>
    </div>
  
  </div>
  
  <mat-card class="addadmin ">
      <label class="inviteuser">Add Partner Category</label>
  <div [formGroup]="partnerForm" class="row">
      <div class="col d-flex justify-content-center">
        <mat-form-field autofocus  appearance="outline">
            <input  matInput placeholder="Name" formControlName="name">
          </mat-form-field>
      </div>
      <div class="col d-flex justify-content-center">
        <mat-form-field appearance="outline">
            <textarea matInput placeholder="Description" formControlName="description"></textarea>
          </mat-form-field>
      </div>





  </div>
  <button (click)="addCategory()" mat-flat-button color="primary">Add</button>
</mat-card>
<div >
</div>

  <label style="margin-left: 20px;" class="inviteuser">Arrange Partner Categories</label>
  <div class="col d-flex justify-content-center">
    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
      <div class="example-box" *ngFor="let category of categoryList" cdkDrag>
        <div class="col">
          <p>{{category.name}}</p>

        </div>
          <div class="col">
            <p style=" text-align: left;">{{category.description}}</p>
            <button class="btn" mat-raised-button (click)="showCancellation(category)">Edit</button>
            <button class="btn" mat-raised-button (click)="showDelete(category.id)">Delete</button>
  
          </div>
       
        

    </div>
    
  </div>
  </div>


  <div [style.display]="cancellationReason ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">Edit Category</h4>
        <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideCancellation()"
          class="material-icons">highlight_off</i>

      </div>
      <div style="display: inline-block;">

        <div class="modal-body">
          <div class="col updatename">
          <mat-label>Name:</mat-label>
          <input [(ngModel)]="name" matInput value={{cancellationArray.name}}/>
        </div>
        <mat-divider></mat-divider>
        <div class="col updatedescription">
          <mat-label>Description:</mat-label>
          <input [(ngModel)]="description" matInput value={{cancellationArray.description}}/>
        </div>
          <button mat-raised-button (click)="update()" class="confirmcancellation">Update</button>
        </div>
        <div class="modal-footer">

        </div>
      </div>
    </div>
  </div>
</div>


<div [style.display]="cancellationReasonDelete ? 'block' : 'none'" class="modal" id="imagemodal" tabindex="-1" role="dialog"
aria-labelledby="myModalLabel" aria-hidden="true">
<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="myModalLabel">Delete Category</h4>
      <i style="cursor: pointer;" style="transform: scale(2);" data-dismiss="modal" (click)="hideDelete()"
        class="material-icons">highlight_off</i>

    </div>
    <div style="display: inline-block;">

      <div class="modal-body">
       
        <mat-label>Are you sure you want to delete this category?</mat-label>

        <button (click)="removeCat()" class="confirmcancellationDelete">Confirm</button>
      </div>
      <div class="modal-footer">

      </div>
    </div>
  </div>
</div>
</div>
